import { render, staticRenderFns } from "./ContactSubmit.vue?vue&type=template&id=19ccbe1e&"
import script from "./ContactSubmit.vue?vue&type=script&lang=js&"
export * from "./ContactSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports